import { rem } from '../utils/polished';

const defaults = {
    radius: rem('8px')
};

export { defaults };
